if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class Header extends HTMLElement {
      constructor() {
        super();
        this.menuOpen = false;
        this.searchActive = false;
      }
    
      connectedCallback() {
        const setDocumentVariables = () => {
          this.submenu = this.querySelector('[data-submenu-wrapper]');
          this.submenuContentArea = this.querySelector('[data-submenu-content-wrapper]');
          this.navWrapper = this.submenu.closest('site-header');
          this.headerHeight = this.closest('.shopify-section-group-header-group') ? this.closest('.shopify-section-group-header-group').offsetHeight : this.closest('.shopify-section.section-header')?.offsetHeight;
          this.searchBar = this.querySelector('predictive-search');
          //this.autoOpen('menu-shop_dropdown_JcQML7');
        };
        
        if (document.readyState === 'complete') {
          setDocumentVariables();
          this.addDelegatedClickListeners();
        } else {
          document.addEventListener('DOMContentLoaded', () => {
            setDocumentVariables();
            this.addDelegatedClickListeners();
          });
        }
        
        window.addEventListener('resize', () => {
          this.headerHeight = this.closest('.shopify-section-group-header-group')?.scrollHeight;
        });
        
        window.addEventListener('scroll', () => {
          if ((window.scrollY > this.lastScroll) && (window.scrollY > (this.headerHeight))) {
            document.body.classList.add('scrolling-down');
          } else {
            document.body.classList.remove('scrolling-down');
          }
          
          this.classList.toggle('at-top', (window.scrollY < this.headerHeight));
          
          this.lastScroll = window.scrollY;
        }, { passive: true });
      }
      
      closeAllMenus() {
        if (!this.menuOpen) return;
          
        this.menuOpen = false;
        this.submenuContentArea.innerHTML = '';
        this.querySelectorAll(`[data-action="open-submenu"][data-menu-id].active`)
          .forEach((submenuToggle) => {
            submenuToggle.classList.remove('active');
          });
        this.querySelectorAll('.slide-in').forEach((x) => x.classList.remove('slide-in'));
        this.classList.remove('slide-in-open');
        document.body.classList.remove('nav-open');
        this.removeTrapFocus();
      }
      
      trapFocus(element = this.querySelector('[data-main-mobile-menu]'), closeButton = false) {
        if (!element) return;
        const focusableElements = element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
        this.focusableClose = closeButton;
        this.firstFocusableEl = focusableElements[0];  
        this.lastFocusableEl = focusableElements[focusableElements.length - 1];
        if ( this.focusableClose) {
          this.focusableClose.focus();
        } else this.firstFocusableEl?.focus();
        this.addEventListener('keydown', (e) => this.focusListener(e));
      }
      
      removeTrapFocus() {
        this.focusableClose = false;
        this.firstFocusableEl = false;  
        this.lastFocusableEl = false;
        this.removeEventListener('keydown', this.focusListener);
      }
      
      focusListener(e) {
        if (e.key === 'Tab' || e.keyCode === 9) {
          if (e.shiftKey ) /* shift + tab */ {
            if (e.target === this.firstFocusableEl) {
              this.focusableClose.focus();
              e.preventDefault();
            }
            if (e.target === this.focusableClose) {
              this.lastFocusableEl.focus();
              e.preventDefault();
            }
          } else /* tab */ {
            if (e.target === this.focusableClose) {
              this.firstFocusableEl.focus();
              e.preventDefault();
            }
            if (e.target === this.lastFocusableEl) {
              this.focusableClose.focus();
              e.preventDefault();
            }
          }
        }
      }
      
      autoOpen(menuId) {
        const actionElement = this.querySelector(`[data-menu-id="${menuId}"]`);
        const template = this.querySelector(`[data-menu-template][data-menu-id="${menuId}"]`);
        if (!template) return;
        
        this.menuOpen = true;
        document.body.classList.add('nav-open');
        actionElement.classList.add('active');
        this.querySelectorAll(`[data-action="open-submenu"]:not([data-menu-id="${menuId}"]).active`)
          .forEach((submenuToggle) => {
            submenuToggle.classList.remove('active');
          });
        this.submenuContentArea.innerHTML = template.innerHTML;
      }
      
      addDelegatedClickListeners() {        
        // this.autoOpen('menu-header-mobile');
        this.navWrapper.addEventListener('mouseleave', () => {
          if (window.matchMedia('(max-width: 979px)').matches) return;
          this.closeAllMenus();
        });
        
        this.addEventListener('keydown', e => {
          const actionElement = e.target.closest('[data-action]');
          if (e.key === "Enter" && actionElement) {
            const {
              action,
              menuId
            } = actionElement.dataset;
            
            if (action !== 'open-submenu') return;
            e.preventDefault();
            
            if (this.menuOpen) {
              this.closeAllMenus();
              return;
            }        
             
            const template = this.querySelector(`[data-menu-template][data-menu-id="${menuId}"]`);
            if (!template) return;
                            
            this.menuOpen = true;
            document.body.classList.add('nav-open');
            actionElement.classList.add('active');
            this.querySelectorAll(`[data-action="open-submenu"]:not([data-menu-id="${menuId}"]).active`)
              .forEach((submenuToggle) => {
                submenuToggle.classList.remove('active');
              });
            this.submenuContentArea.innerHTML = template.innerHTML;
            this.trapFocus(this.submenuContentArea, actionElement);
            setTimeout(() => {
              window.dispatchEvent(new Event('cart:updateCartCount', { bubbles: true }));
            }, 100);
          }
        });
        
        ['click', 'mouseover'].forEach(eventType => {
          this.addEventListener(eventType, (e) => {
            const actionElement = e.target.closest('[data-action]');
            if (!actionElement) return;
            if (eventType === 'mouseover' && window.matchMedia('(max-width: 979px)').matches) return;
            
            const {
              action,
              menuId
            } = actionElement.dataset;
            
            switch (action) {
              case 'close-submenu':
                this.closeAllMenus();
              break;
              case 'open-submenu':                
                const template = this.querySelector(`[data-menu-template][data-menu-id="${menuId}"]`);
                if (!template) return;
                                
                this.menuOpen = true;
                document.body.classList.add('nav-open');
                actionElement.classList.add('active');
                this.querySelectorAll(`[data-action="open-submenu"]:not([data-menu-id="${menuId}"]).active`)
                  .forEach((submenuToggle) => {
                    submenuToggle.classList.remove('active');
                  });
                this.submenuContentArea.innerHTML = template.innerHTML;
                this.trapFocus();
                setTimeout(() => {
                  window.dispatchEvent(new Event('cart:updateCartCount', { bubbles: true }));
                }, 100);

                const submenu = document.querySelector(`[data-submenu-content-wrapper]`);
                const submenu_wishlist_count = submenu.querySelector(`[data-wishlist-count]`);

                if (wishlist_items?.length > 0 && submenu_wishlist_count) {
                  submenu_wishlist_count.classList.remove(`hidden`);
                  submenu_wishlist_count.classList.add(`block`);
                  submenu_wishlist_count.innerHTML = wishlist_items.length;
                } else {
                  submenu_wishlist_count.classList.remove(`block`);
                  submenu_wishlist_count.classList.add(`hidden`);
                  submenu_wishlist_count.innerHTML = ``;
                }
              break;
              case 'open-slide-in':
                const slideInMenu = this.querySelector(`[data-slidein-id="${menuId}"]`);
                slideInMenu.classList.add('slide-in');
                this.removeTrapFocus();
                this.trapFocus(slideInMenu);
                this.querySelectorAll(`[data-slidein-id]:not([data-slidein-id="${menuId}"]).slide-in`)
                  .forEach((otherSlideIn) => {
                    otherSlideIn.classList.remove('slide-in');
                  }); 
                this.classList.add('slide-in-open');
              break;
              case 'close-slide-in':
                this.querySelectorAll('.slide-in').forEach((x) => x.classList.remove('slide-in'));
                this.classList.remove('slide-in-open');
                this.removeTrapFocus();
                this.trapFocus();
              break;
              default: break;
            }
          });
        });
      }
    }
  )
}